import WorkerApiService from "../../workerApiServices";

class GrupoDePagamentoService extends WorkerApiService {

    constructor() {
        super('/api/grupoDePagamento')
    }


    search() {
        return this.get("/search")
    }

    /*
    Os métodos abaixo foram movidos para CadastroContasAPagarService, pois agora são feitos ao central
    para que replique em todas as empresas.
    */


    // save(object){
    //     return this.post("/save", object)
    // }

    // update(object){
    //     return this.put("/update", object)
    // }

    // deleteById(id){
    //     return this.delete(`/delete/${id}`)
    // }

}

export default GrupoDePagamentoService